import moment from "moment";
import shmuhelper from "./shmu-helper";

export default
{
    legend: {
        enabled: true,
        layout: 'horizontal',
        align: 'center',
        symbolRadius: 0,
        itemMarginTop: 2,
        symbolHeight:12,
        margin: 5,
        padding: 5,
        itemStyle:{ fontSize:'9px', fontWeight:'normal'},

    },
    credits: {
        enabled:false
    },
    chart: {
        marginLeft: 70,
        marginRight: 20,
        height:'400px',
        spacingTop: 10,
        spacingBottom: 20,
        spacingRight: 10,
        zoomType: '',
        style: { fontFamily: 'Tahoma' },
        animation:false,
        plotBackgroundColor: '#6699FF',
        events: {
            // load: initGraph
        },


    },
    title: {
        text: 'Režim podzemných vôd<br> v porovnaní s referenčným obdobím 1981–2010',
        enabled: true,
        style: {
            fontSize: '14px',
            color: '#004fb0',
            margin: 0,
            useHTML:true
        }
    },
    subtitle: {
        text: null
    },
    xAxis: {
        title: { text:null },
        type: 'datetime',
        tickInterval: 30* 24 * 3600 * 1000,
        dateTimeLabelFormats: {day: '%e. %B'},
        tickWidth: 1,  gridLineWidth: 0,
        labels:{ style: { fontSize:'11px' },   rotation: 270, x:0, y:12},
        gridLineDashStyle: 'Dot',
        lineWidth: 2,
        crosshair: true,
        plotLines: [],


    },
    yAxis: {
        title: {
            text: '',
            useHTML: true,
            style: { fontSize:'11px' },
        },
        tickInterval:0.5,
        tickWidth: 1,  gridLineWidth: 0,
        animation:false,
        minPadding: 0,
        maxPadding: 0,
        plotLines: [],
        plotBands: [],

    },
    tooltip: {
        positioner: function () {
            return {
                x: this.chart.chartWidth - this.label.width - 10, // right aligned
                y: 40 // align to title
            };
        },
        borderWidth: 0,
        backgroundColor: 'none',
        useHTML: true,
        formatter: function()
        {
            if (this.series.userOptions.id === 'uh2') {
                let ds_unit = this.series.options.unit;
                let kvantily = this.series.userOptions.kvantily;
                let res = shmuhelper.getKvantilTrans(this.x, this.y, kvantily);
                let add = '<span style="float:right; margin-right:10px; display:block; text-align: right; font-size:10px; font-weight: normal; color:#000;">' + res + '</span>';
                return '<span style="color:#000; font-size:10px; margin-right: 10px; display:block; float:right; text-align: right">' + moment.unix(this.x / 1000).format('D.M.Y HH:mm') + '</span> <strong style="float:right; margin-right:10px; display:block; text-align: right">' + this.y + ' ' + ds_unit + '</strong>' + add;
            }
            return false;
        },
        headerFormat: '',
        shadow: false,
        style: {
            fontSize: '18px',
            // color: dataset.color
        },
        // valueDecimals: dataset.valueDecimals


    },
    plotOptions: {
        spline: {
            connectNulls: false,
            animation: false,
            states: {
                hover: {
                    lineWidthPlus: 0
                }
            }

        },
        area: {
            connectNulls: false,
            animation: false,
            fillOpacity:1,
            marker: {
                enabled: false,
                states: {
                    hover: {
                        enabled: false
                    }
                }

            },
            states: {
                hover: {
                    lineWidthPlus: 0
                }
            }


        },
        states:{
            hover:{
                enabled:true
            }
        },
        series: {
            states:{
                inactive: {
                    opacity: 1
                }
            },

        }
    },
    series: [
        {
            id:'uh2',
            plotBackgrounColor:'#6699FF',
            name:'Úroveň hladiny PzV',
            title:'',
            type: 'spline',
            marker: { enabled: false},
            unit:'',
            tooltip: { valueSuffix: '' },
            color:'#0015FF', tickInterval:0.5, animation:false,
            data:[],
            zIndex:101,
            showInLegend:false,
        },
        {id:'f10', name:'sucho', title:'sucho', type: 'area', marker: { enabled: false}, color:'#FF5050',  animation:false, zIndex:100, data:[] },
        {id:'f40', name:'mierne sucho', title:'mierne sucho', type: 'area', marker: { enabled: false}, color:'#FFCC99',animation:false, zIndex:99, data:[]},
        {id:'f60', name:'normál', title:'normál', type: 'area', marker: { enabled: false}, color:'#FFFFFF', animation:false, zIndex:98, data:[] },
        {id:'f90', name:'mierne nadpriemerná hladina', title:'mierne nadpriemerná hladina', type: 'area', marker: { enabled: false}, color:'#AFC2F7', animation:false, zIndex:97, data:[] },
        {id:'f90p', name:'nadpriemerná hladina', title:'nadpriemerná hladina', type: 'area', marker: { enabled: false}, color:'#6699FF',animation:false, zIndex:96, data:[] },

        {id:'ep_uh2_min', name:'dlhodobé minimum 1981-2010', type: 'line', marker: { enabled: false}, dashStyle: 'ShortDot', color: 'rgb(193,3,3)', animation:false, data:[] },
        {id:'ep_uh2_max', name:'dlhodobé maximum 1981-2010', type: 'line', marker: { enabled: false}, dashStyle: 'ShortDot', color: 'rgb(21,107,196)', animation:false, data:[] },
        {id:'ep_uh2_avg', name:'dlhodobý priemer 1981-2010', type: 'line', marker: { enabled: false}, dashStyle: 'ShortDot', color: 'rgb(2,161,69)', animation:false, data:[] },



    ]
}